import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import {
  SportingSecureParams,
  TSportingUserInfo
} from 'services/sporting/types';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';
import { appendFormDataWithObjectValues } from 'utils/appendFormDataWithObjectValues';

type ChangeEmployeeOrderPayload = {
  from: number;
  to: number;
};

export const changeEmployeeOrder = async (
  params: SportingSecureParams<ChangeEmployeeOrderPayload>
): Promise<TSportingUserInfo[]> => {
  const { payload } = params;

  const endpointURL = getSportingServiceURL('changeEmployeeOrder');

  const headers = createSportingHeaders();

  const body = new FormData();
  appendFormDataWithObjectValues(body, payload);

  const response = await customFetch(endpointURL, {
    method: 'POST',
    headers,
    body
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }

  return response.json();
};
